import React from 'react'

const HeartOutLine = ({ onClick }) => {
  return (
    <svg
      style={{ cursor: 'pointer' }}
      onClick={onClick}
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.65 17.8004L6.925 16.2254C5.15833 14.6087 3.56267 13.0044 2.138 11.4124C0.712667 9.82106 0 8.06706 0 6.15039C0 4.58372 0.525 3.27539 1.575 2.22539C2.625 1.17539 3.93333 0.650391 5.5 0.650391C6.38333 0.650391 7.21667 0.837724 8 1.21239C8.78333 1.58772 9.45 2.10039 10 2.75039C10.55 2.10039 11.2167 1.58772 12 1.21239C12.7833 0.837724 13.6167 0.650391 14.5 0.650391C16.0667 0.650391 17.375 1.17539 18.425 2.22539C19.475 3.27539 20 4.58372 20 6.15039C20 8.06706 19.2917 9.82539 17.875 11.4254C16.4583 13.0254 14.85 14.6337 13.05 16.2504L11.35 17.8004C10.9667 18.1671 10.5167 18.3504 10 18.3504C9.48333 18.3504 9.03333 18.1671 8.65 17.8004ZM9.05 4.75039C8.56667 4.06706 8.05 3.54606 7.5 3.18739C6.95 2.82939 6.28333 2.65039 5.5 2.65039C4.5 2.65039 3.66667 2.98372 3 3.65039C2.33333 4.31706 2 5.15039 2 6.15039C2 7.01706 2.30833 7.93772 2.925 8.91239C3.54167 9.88772 4.27933 10.8337 5.138 11.7504C5.996 12.6671 6.87933 13.5254 7.788 14.3254C8.696 15.1254 9.43333 15.7837 10 16.3004C10.5667 15.7837 11.3043 15.1254 12.213 14.3254C13.121 13.5254 14.0043 12.6671 14.863 11.7504C15.721 10.8337 16.4583 9.88772 17.075 8.91239C17.6917 7.93772 18 7.01706 18 6.15039C18 5.15039 17.6667 4.31706 17 3.65039C16.3333 2.98372 15.5 2.65039 14.5 2.65039C13.7167 2.65039 13.05 2.82939 12.5 3.18739C11.95 3.54606 11.4333 4.06706 10.95 4.75039C10.8333 4.91706 10.6917 5.04206 10.525 5.12539C10.3583 5.20872 10.1833 5.25039 10 5.25039C9.81667 5.25039 9.64167 5.20872 9.475 5.12539C9.30833 5.04206 9.16667 4.91706 9.05 4.75039Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default HeartOutLine
